module.exports = __webpack_public_path__ + "media/svg/ws-a5bc5f08.svg";